<script lang="ts" setup>
import PhotoData from './wellbeing-sale--forEmploy--const'
import type { IPhotoWithDescriptionFields } from '@/types/contentful.ts'
import UiPhotoWithDescription from '@/components/UiPhotoWithDescription/UiPhotoWithDescription.vue'

const { uiPhotoData } = PhotoData()

</script>

<template>
  <div class="for-employ">
    <UiPhotoWithDescription
      v-bind="uiPhotoData() as unknown as IPhotoWithDescriptionFields"
    />
  </div>
</template>

<style lang="scss" scoped>
.for-employ {
  padding: 4rem 1.6rem;
  :deep(.cf-photoWithDescription__list .bold) {
    font-weight: 600;
  }
}

@include atM {
  .for-employ {
    padding: 11rem 0;
  }
}
</style>
